import React, { useRef, useEffect, forwardRef } from 'react';
import { Trash2 } from 'lucide-react';
import type { CandidateInputProps } from './types';

export const CandidateInput = forwardRef<HTMLInputElement, CandidateInputProps>(({ 
  value, 
  index, 
  showRemove, 
  onChange, 
  onRemove,
  onEnter,
  autoFocus 
}, ref) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onEnter(index);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => onChange(index, e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={`Candidate ${index + 1}`}
        className="flex-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100 dark:placeholder-gray-400"
        autoFocus={autoFocus}
      />
      {showRemove && (
        <button
          type="button"
          onClick={() => onRemove(index)}
          className="p-2 text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
        >
          <Trash2 size={20} />
        </button>
      )}
    </div>
  );
});

CandidateInput.displayName = 'CandidateInput';